import { useEffect, useRef, useState, type FormEvent } from 'react';
import { useGame } from '../../game/store';
import { useGameInstance } from './GameContext';

export function Chat() {
  const game = useGameInstance();
  const lines = useGame((s) => s.chat);
  const [text, setText] = useState('');
  const input = useRef<HTMLInputElement>(null);
  const log = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const focus = (): void => input.current?.focus();
    window.addEventListener('jh-focus-chat', focus);
    return () => window.removeEventListener('jh-focus-chat', focus);
  }, []);
  useEffect(() => {
    if (log.current) log.current.scrollTop = log.current.scrollHeight;
  }, [lines]);

  const submit = (e: FormEvent): void => {
    e.preventDefault();
    if (text.trim()) game?.sendChat(text);
    setText('');
    input.current?.blur();
  };

  return (
    <section className="chat" aria-label="Chat">
      <div className="chat-log" ref={log} aria-live="polite">
        {lines.length === 0 && (
          <div className="muted">Press Enter to chat with others in this zone. Type /help for commands.</div>
        )}
        {lines.map((l) => (
          <div key={l.id} className={`chat-line ${l.ch}`}>
            {l.from && <span className="from">{l.from}: </span>}
            {l.text}
          </div>
        ))}
      </div>
      <form onSubmit={submit}>
        <input
          ref={input}
          className="chat-input"
          style={{ width: '100%' }}
          value={text}
          maxLength={200}
          placeholder="Press Enter to chat…"
          aria-label="Chat message"
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              setText('');
              input.current?.blur();
            }
            e.stopPropagation();
          }}
        />
      </form>
    </section>
  );
}
